import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { Box } from '@mui/material';
import { Link } from 'react-router';

import type { Leistung } from '../../dtos.ts';

import { useConfiguredUrl } from '../../appRouter/url.ts';
import { content } from '../../utils';

export const AusschreibungLink = ({ leistung }: { leistung?: Leistung }) => {
  const { configuredUrl } = useConfiguredUrl();

  if (!leistung) {
    return content.noInfoAvailable;
  }

  return (
    <Box>
      <OpenInNewOutlinedIcon sx={{ mr: 0.5, fontSize: '16px', color: 'text.brand' }} />
      <Link target="_blank" rel="noopener" to={configuredUrl.ausschreibungsportal.ausschreibungByLeistung(leistung)}>
        {leistung.leistungId}
      </Link>
    </Box>
  );
};
